<main class="content-area">
  <div class="reports">
    <div class="header-row">
      <app-page-header
        title="Reports & Analytics"
        subtitle="Comprehensive insights and analytics"
      ></app-page-header>

          <div class="exports">
            <!-- <button type="button" class="page-btn page-btn-primary" (click)="exportPdf()">
              Export PDF
            </button> -->
            <button type="button" class="page-btn page-btn-secondary" (click)="exportExcel()">
              Export Excel
            </button>
          </div>
        </div>

        <div class="filters">
          <select
            class="page-select"
            aria-label="Date range"
            [value]="dateRangePreset"
            (change)="onDateRangePresetChange($any($event.target).value)"
          >
            <option value="all_time">All time</option>
            <option value="last_7_days">Last 7 Days</option>
            <option value="last_30_days">Last 30 Days</option>
            <option value="year_to_date">Year to Date</option>
            <option value="custom">Custom Range</option>
          </select>

          <input
            class="page-control"
            type="date"
            aria-label="From date"
            [value]="fromDate"
            (change)="onFromDateChange($any($event.target).value)"
            [max]="toDate || null"
            [disabled]="dateRangePreset !== 'custom'"
          />

          <input
            class="page-control"
            type="date"
            aria-label="To date"
            [value]="toDate"
            (change)="onToDateChange($any($event.target).value)"
            [min]="fromDate || null"
            [disabled]="dateRangePreset !== 'custom'"
          />

      <select
        class="page-select"
        aria-label="MDA filter"
        [value]="selectedMdaId"
        (change)="onMdaChange($any($event.target).value)"
      >
        <option value="">All MDAs</option>
        <option *ngFor="let mda of mdas" [value]="mda.id">
          {{ mda.name }}
        </option>
      </select>

      <select
        class="page-select"
        aria-label="Category filter"
        [value]="selectedCategoryId"
        (change)="onCategoryChange($any($event.target).value)"
      >
        <option value="">All Categories</option>
        <option *ngFor="let category of categoryOptions" [value]="category.id">
          {{ category.name }}
        </option>
      </select>

      <select
        class="page-select"
        aria-label="Payment channel filter"
        [value]="selectedPaymentChannel"
        (change)="onPaymentChannelChange($any($event.target).value)"
      >
        <option value="">All Payment Channels</option>
        <option *ngFor="let channel of paymentChannelOptions" [value]="channel">
          {{ channel }}
        </option>
      </select>
    </div>

    <app-stats-grid [cards]="statCards" [columns]="4"></app-stats-grid>

    <div class="charts-grid mb-3">
      <div class="chart-col max-h-96">
        <app-revenue-trend [points]="revenueTrend"></app-revenue-trend>
        <div *ngIf="revenueTrendEmptyMessage" class="mt-2 text-sm text-slate-500">
          {{ revenueTrendEmptyMessage }}
        </div>
      </div>
      <div class="chart-col max-h-96">
        <app-category-chart
          title="Vendor Distribution by Category"
          [categories]="categories"
        ></app-category-chart>
      </div>
    </div>

    <div class="charts-grid">
      <div class="chart-col max-h-96">
        <app-vendors-by-mda-chart [data]="vendorsByMda"></app-vendors-by-mda-chart>
      </div>
      <div class="chart-col max-h-96">
        <app-payment-methods-chart
          [methods]="paymentMethods"
        ></app-payment-methods-chart>
      </div>
    </div>

    <app-category-fee-summary
      [rows]="categoryFeeSummary"
    ></app-category-fee-summary>
  </div>
</main>
